import { render, staticRenderFns } from "./VotersOnActualization.vue?vue&type=template&id=db25dad8"
import script from "./VotersOnActualization.vue?vue&type=script&lang=js"
export * from "./VotersOnActualization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports